// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Step3LandingPage.css */

.step3-container {
    max-width: 1300px;
    margin: 2rem auto;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
    color: #34495e;
    background: #f9fbfc;
    padding: 1rem;
    border-radius: 12px;
    box-shadow: 0 10px 30px rgba(0,0,0,0.1);
}

.step3-header {
    margin-bottom: 1.5rem;
}

    .step3-header h2 {
        font-weight: 600;
        font-size: 1.8rem;
        color: #2c3e50;
        text-align: center;
    }

.step3-content {
    display: flex;
    gap: 2rem;
    align-items: flex-start;
}

.step3-main {
    flex: 3 1;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
}

/* Card style for sections */
.card {
    background: white;
    padding: 1.5rem 2rem;
    border-radius: 12px;
    box-shadow: 0 3px 10px rgba(0,0,0,0.05);
    border: 1px solid #dde6ea;
}

/* Section titles */
.card-title {
    font-size: 1.3rem;
    font-weight: 500;
    color: #1f2d3d;
    margin-bottom: 1rem;
    border-bottom: 2px solid #0061b0;
    padding-bottom: 6px;
}

/* Input row for basics */
.input-row {
    display: flex;
    gap: 2rem;
    flex-wrap: wrap;
}

    .input-row label {
        flex: 1 1 45%;
        display: flex;
        flex-direction: column;
        font-weight: 400;
        color: #4a5a6a;
    }

input[type="number"],
input[type="text"],
textarea,
select {
    margin-top: 6px;
    padding: 10px 12px;
    border-radius: 8px;
    border: 1.5px solid #d0d7de;
    font-size: 1rem;
    transition: border-color 0.2s ease;
    font-family: inherit;
    font-weight: 400;
    color: #34495e;
}

    input[type="number"]:focus,
    input[type="text"]:focus,
    textarea:focus,
    select:focus {
        border-color: #0061b0;
        outline: none;
    }

/* Textarea */
textarea {
    resize: vertical;
    min-height: 80px;
}

/* Save basics button */
.save-basics-btn {
    background-color: #0061b0;
    color: white;
    padding: 12px 30px;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-weight: 600;
    align-self: flex-start;
    transition: background-color 0.3s ease;
    margin-top: 1rem;
}

    .save-basics-btn:hover {
        background-color: #004880;
    }

/* Reporting checkboxes container */
.reporting-checkboxes-card .checkboxes-container {
    display: flex;
    flex-wrap: wrap;
    gap: 24px;
}

.reporting-label {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    font-weight: 400;
    font-size: 0.95rem;
    color: #2c3e50;
    -webkit-user-select: none;
            user-select: none;
    min-width: 200px;
}

.reporting-checkbox {
    width: 18px;
    height: 18px;
    cursor: pointer;
}

/* Icons color */
.icon-danger {
    color: #d9534f;
}

.icon-cargo {
    color: #0275d8;
}

.icon-shipstores {
    color: #5bc0de;
}

.icon-crew {
    color: #5cb85c;
}

.icon-pax {
    color: #f0ad4e;
}

.icon-security {
    color: #292b2c;
}

/* Status badges */
.status-indicator {
    margin-left: auto;
    font-weight: 600;
    text-transform: capitalize;
    padding: 2px 10px;
    border-radius: 9999px;
    font-size: 0.85rem;
    min-width: 80px;
    text-align: center;
    -webkit-user-select: none;
            user-select: none;
    box-shadow: 0 0 6px rgb(0 0 0 / 0.1);
}

    .status-indicator.pending {
        background-color: #f8d7da;
        color: #721c24;
    }

    .status-indicator.in-progress {
        background-color: #fff3cd;
        color: #856404;
    }

    .status-indicator.completed {
        background-color: #d4edda;
        color: #155724;
    }

/* Form wrapper */
.form-wrapper {
    margin-top: 1rem;
    padding-top: 1rem;
    border-top: 1.5px solid #e3e9ed;
}

/* Navigation buttons */
.step3-navigation {
    display: flex;
    justify-content: space-between;
    margin-top: 2rem;
}

.btn {
    padding: 14px 36px;
    font-weight: 600;
    font-size: 1.1rem;
    border-radius: 8px;
    border: none;
    cursor: pointer;
    transition: background-color 0.3s ease;
    -webkit-user-select: none;
            user-select: none;
    min-width: 160px;
}

.btn-back {
    background-color: #6c757d;
    color: white;
}

    .btn-back:hover {
        background-color: #5a6268;
    }

.btn-confirm {
    background-color: #0061b0;
    color: white;
}

    .btn-confirm:hover {
        background-color: #004880;
    }

/* Sidebar */
.step3-sidebar {
    flex: 1 1;
    background: white;
    padding: 1.5rem;
    border-radius: 12px;
    border: 1px solid #dde6ea;
    box-shadow: 0 3px 15px rgba(0,0,0,0.05);
    height: fit-content;
    position: sticky;
    top: 20px;
    font-size: 0.95rem;
    color: #34495e;
}

    .step3-sidebar h3,
    .step3-sidebar h4 {
        font-weight: 500;
        margin-bottom: 0.75rem;
        color: #1f2d3d;
    }

.summary-list,
.status-list {
    list-style: none;
    padding-left: 0;
    margin-bottom: 1.25rem;
}

    .summary-list li,
    .status-list li {
        margin-bottom: 0.6rem;
        font-weight: 400;
        line-height: 1.3;
    }

/* Responsive */

@media (max-width: 1024px) {
    .step3-content {
        flex-direction: column;
    }

    .step3-sidebar {
        position: relative;
        top: auto;
        margin-top: 2rem;
    }

    .step3-navigation {
        flex-direction: column;
        gap: 12px;
    }

    .btn {
        min-width: 100%;
    }
}
/* Container for main content and sidebar */
.step3-content {
    display: flex;
    gap: 2rem;
    margin-top: 1rem;
}

/* Main form container takes more width */
.step3-main {
    flex: 3 1;
    background: #fff;
    padding: 1.5rem;
    border-radius: 8px;
    box-shadow: 0 0 12px rgba(0,0,0,0.1);
    overflow-y: auto;
}

/* Sidebar container */
.step3-sidebar {
    flex: 1 1;
    background: #f9fafb;
    padding: 1rem 1.5rem;
    border-radius: 8px;
    box-shadow: 0 0 12px rgba(0,0,0,0.05);
    max-height: fit-content;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    color: #2c3e50;
}

/* Summary list styling */
.summary-list,
.status-list {
    list-style-type: none;
    padding-left: 0;
    margin-top: 0.5rem;
}

    .summary-list li,
    .status-list li {
        padding: 0.3rem 0;
        border-bottom: 1px solid #e0e0e0;
        font-weight: 500;
        font-size: 0.9rem;
    }

/* Status indicator styling */
.status-indicator {
    display: inline-block;
    padding: 3px 9px;
    border-radius: 15px;
    font-size: 0.8rem;
    font-weight: 600;
    color: white;
    text-transform: capitalize;
}

    /* Status colors */
    .status-indicator.completed {
        background-color: #27ae60; /* Green */
    }

    .status-indicator.in-progress {
        background-color: #f39c12; /* Orange */
    }

    .status-indicator.pending,
    .status-indicator.undefined {
        background-color: #7f8c8d; /* Gray */
    }

/* Optional: hover effect on summary items */
.summary-list li:hover {
    background-color: #f0f8ff;
}
.step3-section {
    background: #fff;
    border-radius: 8px;
    padding: 1.5rem;
    margin-bottom: 1.5rem;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}

    .step3-section h4 {
        margin-bottom: 1rem;
        font-size: 1.2rem;
        border-bottom: 1px solid #ccc;
        padding-bottom: 0.5rem;
    }

.step3-actions {
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
    margin-top: 2rem;
}

.step3-button {
    padding: 10px 20px;
    background-color: #005fa3;
    color: white;
    font-weight: bold;
    border-radius: 5px;
    border: none;
    cursor: pointer;
}

    .step3-button:hover {
        background-color: #004476;
    }

    .step3-button:disabled {
        background-color: #cccccc;
        cursor: not-allowed;
    }
`, "",{"version":3,"sources":["webpack://./src/pages/demo/PortCall/Step3LandingPage.css"],"names":[],"mappings":"AAAA,yBAAyB;;AAEzB;IACI,iBAAiB;IACjB,iBAAiB;IACjB,iJAAiJ;IACjJ,cAAc;IACd,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uCAAuC;AAC3C;;AAEA;IACI,qBAAqB;AACzB;;IAEI;QACI,gBAAgB;QAChB,iBAAiB;QACjB,cAAc;QACd,kBAAkB;IACtB;;AAEJ;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA,4BAA4B;AAC5B;IACI,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,uCAAuC;IACvC,yBAAyB;AAC7B;;AAEA,mBAAmB;AACnB;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,SAAS;IACT,eAAe;AACnB;;IAEI;QACI,aAAa;QACb,aAAa;QACb,sBAAsB;QACtB,gBAAgB;QAChB,cAAc;IAClB;;AAEJ;;;;IAII,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,2BAA2B;IAC3B,eAAe;IACf,kCAAkC;IAClC,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;AAClB;;IAEI;;;;QAII,qBAAqB;QACrB,aAAa;IACjB;;AAEJ,aAAa;AACb;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,uBAAuB;AACvB;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,sCAAsC;IACtC,gBAAgB;AACpB;;IAEI;QACI,yBAAyB;IAC7B;;AAEJ,mCAAmC;AACnC;IACI,aAAa;IACb,eAAe;IACf,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,yBAAiB;YAAjB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA,gBAAgB;AAChB;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,kBAAkB;AAClB;IACI,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;IAC1B,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,yBAAiB;YAAjB,iBAAiB;IACjB,oCAAoC;AACxC;;IAEI;QACI,yBAAyB;QACzB,cAAc;IAClB;;IAEA;QACI,yBAAyB;QACzB,cAAc;IAClB;;IAEA;QACI,yBAAyB;QACzB,cAAc;IAClB;;AAEJ,iBAAiB;AACjB;IACI,gBAAgB;IAChB,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,sCAAsC;IACtC,yBAAiB;YAAjB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;IAEI;QACI,yBAAyB;IAC7B;;AAEJ;IACI,yBAAyB;IACzB,YAAY;AAChB;;IAEI;QACI,yBAAyB;IAC7B;;AAEJ,YAAY;AACZ;IACI,SAAO;IACP,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,uCAAuC;IACvC,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;IACT,kBAAkB;IAClB,cAAc;AAClB;;IAEI;;QAEI,gBAAgB;QAChB,sBAAsB;QACtB,cAAc;IAClB;;AAEJ;;IAEI,gBAAgB;IAChB,eAAe;IACf,sBAAsB;AAC1B;;IAEI;;QAEI,qBAAqB;QACrB,gBAAgB;QAChB,gBAAgB;IACpB;;AAEJ,eAAe;;AAEf;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;AACJ;AACA,2CAA2C;AAC3C;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA,yCAAyC;AACzC;IACI,SAAO;IACP,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,oCAAoC;IACpC,gBAAgB;AACpB;;AAEA,sBAAsB;AACtB;IACI,SAAO;IACP,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,qCAAqC;IACrC,uBAAuB;IACvB,4DAA4D;IAC5D,cAAc;AAClB;;AAEA,yBAAyB;AACzB;;IAEI,qBAAqB;IACrB,eAAe;IACf,kBAAkB;AACtB;;IAEI;;QAEI,iBAAiB;QACjB,gCAAgC;QAChC,gBAAgB;QAChB,iBAAiB;IACrB;;AAEJ,6BAA6B;AAC7B;IACI,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,0BAA0B;AAC9B;;IAEI,kBAAkB;IAClB;QACI,yBAAyB,EAAE,UAAU;IACzC;;IAEA;QACI,yBAAyB,EAAE,WAAW;IAC1C;;IAEA;;QAEI,yBAAyB,EAAE,SAAS;IACxC;;AAEJ,4CAA4C;AAC5C;IACI,yBAAyB;AAC7B;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,qBAAqB;IACrB,yCAAyC;AAC7C;;IAEI;QACI,mBAAmB;QACnB,iBAAiB;QACjB,6BAA6B;QAC7B,sBAAsB;IAC1B;;AAEJ;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,eAAe;AACnB;;IAEI;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;QACzB,mBAAmB;IACvB","sourcesContent":["/* Step3LandingPage.css */\n\n.step3-container {\n    max-width: 1300px;\n    margin: 2rem auto;\n    font-family: 'Inter', -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n    color: #34495e;\n    background: #f9fbfc;\n    padding: 1rem;\n    border-radius: 12px;\n    box-shadow: 0 10px 30px rgba(0,0,0,0.1);\n}\n\n.step3-header {\n    margin-bottom: 1.5rem;\n}\n\n    .step3-header h2 {\n        font-weight: 600;\n        font-size: 1.8rem;\n        color: #2c3e50;\n        text-align: center;\n    }\n\n.step3-content {\n    display: flex;\n    gap: 2rem;\n    align-items: flex-start;\n}\n\n.step3-main {\n    flex: 3;\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n}\n\n/* Card style for sections */\n.card {\n    background: white;\n    padding: 1.5rem 2rem;\n    border-radius: 12px;\n    box-shadow: 0 3px 10px rgba(0,0,0,0.05);\n    border: 1px solid #dde6ea;\n}\n\n/* Section titles */\n.card-title {\n    font-size: 1.3rem;\n    font-weight: 500;\n    color: #1f2d3d;\n    margin-bottom: 1rem;\n    border-bottom: 2px solid #0061b0;\n    padding-bottom: 6px;\n}\n\n/* Input row for basics */\n.input-row {\n    display: flex;\n    gap: 2rem;\n    flex-wrap: wrap;\n}\n\n    .input-row label {\n        flex: 1 1 45%;\n        display: flex;\n        flex-direction: column;\n        font-weight: 400;\n        color: #4a5a6a;\n    }\n\ninput[type=\"number\"],\ninput[type=\"text\"],\ntextarea,\nselect {\n    margin-top: 6px;\n    padding: 10px 12px;\n    border-radius: 8px;\n    border: 1.5px solid #d0d7de;\n    font-size: 1rem;\n    transition: border-color 0.2s ease;\n    font-family: inherit;\n    font-weight: 400;\n    color: #34495e;\n}\n\n    input[type=\"number\"]:focus,\n    input[type=\"text\"]:focus,\n    textarea:focus,\n    select:focus {\n        border-color: #0061b0;\n        outline: none;\n    }\n\n/* Textarea */\ntextarea {\n    resize: vertical;\n    min-height: 80px;\n}\n\n/* Save basics button */\n.save-basics-btn {\n    background-color: #0061b0;\n    color: white;\n    padding: 12px 30px;\n    border: none;\n    border-radius: 8px;\n    cursor: pointer;\n    font-weight: 600;\n    align-self: flex-start;\n    transition: background-color 0.3s ease;\n    margin-top: 1rem;\n}\n\n    .save-basics-btn:hover {\n        background-color: #004880;\n    }\n\n/* Reporting checkboxes container */\n.reporting-checkboxes-card .checkboxes-container {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 24px;\n}\n\n.reporting-label {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    cursor: pointer;\n    font-weight: 400;\n    font-size: 0.95rem;\n    color: #2c3e50;\n    user-select: none;\n    min-width: 200px;\n}\n\n.reporting-checkbox {\n    width: 18px;\n    height: 18px;\n    cursor: pointer;\n}\n\n/* Icons color */\n.icon-danger {\n    color: #d9534f;\n}\n\n.icon-cargo {\n    color: #0275d8;\n}\n\n.icon-shipstores {\n    color: #5bc0de;\n}\n\n.icon-crew {\n    color: #5cb85c;\n}\n\n.icon-pax {\n    color: #f0ad4e;\n}\n\n.icon-security {\n    color: #292b2c;\n}\n\n/* Status badges */\n.status-indicator {\n    margin-left: auto;\n    font-weight: 600;\n    text-transform: capitalize;\n    padding: 2px 10px;\n    border-radius: 9999px;\n    font-size: 0.85rem;\n    min-width: 80px;\n    text-align: center;\n    user-select: none;\n    box-shadow: 0 0 6px rgb(0 0 0 / 0.1);\n}\n\n    .status-indicator.pending {\n        background-color: #f8d7da;\n        color: #721c24;\n    }\n\n    .status-indicator.in-progress {\n        background-color: #fff3cd;\n        color: #856404;\n    }\n\n    .status-indicator.completed {\n        background-color: #d4edda;\n        color: #155724;\n    }\n\n/* Form wrapper */\n.form-wrapper {\n    margin-top: 1rem;\n    padding-top: 1rem;\n    border-top: 1.5px solid #e3e9ed;\n}\n\n/* Navigation buttons */\n.step3-navigation {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 2rem;\n}\n\n.btn {\n    padding: 14px 36px;\n    font-weight: 600;\n    font-size: 1.1rem;\n    border-radius: 8px;\n    border: none;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n    user-select: none;\n    min-width: 160px;\n}\n\n.btn-back {\n    background-color: #6c757d;\n    color: white;\n}\n\n    .btn-back:hover {\n        background-color: #5a6268;\n    }\n\n.btn-confirm {\n    background-color: #0061b0;\n    color: white;\n}\n\n    .btn-confirm:hover {\n        background-color: #004880;\n    }\n\n/* Sidebar */\n.step3-sidebar {\n    flex: 1;\n    background: white;\n    padding: 1.5rem;\n    border-radius: 12px;\n    border: 1px solid #dde6ea;\n    box-shadow: 0 3px 15px rgba(0,0,0,0.05);\n    height: fit-content;\n    position: sticky;\n    top: 20px;\n    font-size: 0.95rem;\n    color: #34495e;\n}\n\n    .step3-sidebar h3,\n    .step3-sidebar h4 {\n        font-weight: 500;\n        margin-bottom: 0.75rem;\n        color: #1f2d3d;\n    }\n\n.summary-list,\n.status-list {\n    list-style: none;\n    padding-left: 0;\n    margin-bottom: 1.25rem;\n}\n\n    .summary-list li,\n    .status-list li {\n        margin-bottom: 0.6rem;\n        font-weight: 400;\n        line-height: 1.3;\n    }\n\n/* Responsive */\n\n@media (max-width: 1024px) {\n    .step3-content {\n        flex-direction: column;\n    }\n\n    .step3-sidebar {\n        position: relative;\n        top: auto;\n        margin-top: 2rem;\n    }\n\n    .step3-navigation {\n        flex-direction: column;\n        gap: 12px;\n    }\n\n    .btn {\n        min-width: 100%;\n    }\n}\n/* Container for main content and sidebar */\n.step3-content {\n    display: flex;\n    gap: 2rem;\n    margin-top: 1rem;\n}\n\n/* Main form container takes more width */\n.step3-main {\n    flex: 3;\n    background: #fff;\n    padding: 1.5rem;\n    border-radius: 8px;\n    box-shadow: 0 0 12px rgba(0,0,0,0.1);\n    overflow-y: auto;\n}\n\n/* Sidebar container */\n.step3-sidebar {\n    flex: 1;\n    background: #f9fafb;\n    padding: 1rem 1.5rem;\n    border-radius: 8px;\n    box-shadow: 0 0 12px rgba(0,0,0,0.05);\n    max-height: fit-content;\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n    color: #2c3e50;\n}\n\n/* Summary list styling */\n.summary-list,\n.status-list {\n    list-style-type: none;\n    padding-left: 0;\n    margin-top: 0.5rem;\n}\n\n    .summary-list li,\n    .status-list li {\n        padding: 0.3rem 0;\n        border-bottom: 1px solid #e0e0e0;\n        font-weight: 500;\n        font-size: 0.9rem;\n    }\n\n/* Status indicator styling */\n.status-indicator {\n    display: inline-block;\n    padding: 3px 9px;\n    border-radius: 15px;\n    font-size: 0.8rem;\n    font-weight: 600;\n    color: white;\n    text-transform: capitalize;\n}\n\n    /* Status colors */\n    .status-indicator.completed {\n        background-color: #27ae60; /* Green */\n    }\n\n    .status-indicator.in-progress {\n        background-color: #f39c12; /* Orange */\n    }\n\n    .status-indicator.pending,\n    .status-indicator.undefined {\n        background-color: #7f8c8d; /* Gray */\n    }\n\n/* Optional: hover effect on summary items */\n.summary-list li:hover {\n    background-color: #f0f8ff;\n}\n.step3-section {\n    background: #fff;\n    border-radius: 8px;\n    padding: 1.5rem;\n    margin-bottom: 1.5rem;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);\n}\n\n    .step3-section h4 {\n        margin-bottom: 1rem;\n        font-size: 1.2rem;\n        border-bottom: 1px solid #ccc;\n        padding-bottom: 0.5rem;\n    }\n\n.step3-actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 1rem;\n    margin-top: 2rem;\n}\n\n.step3-button {\n    padding: 10px 20px;\n    background-color: #005fa3;\n    color: white;\n    font-weight: bold;\n    border-radius: 5px;\n    border: none;\n    cursor: pointer;\n}\n\n    .step3-button:hover {\n        background-color: #004476;\n    }\n\n    .step3-button:disabled {\n        background-color: #cccccc;\n        cursor: not-allowed;\n    }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
